"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionIterator = exports.ParagraphIterator = exports.OneDimensionItertor = void 0;
var tslib_1 = require("tslib");
var search_1 = require("@devexpress/utils/lib/utils/search");
var OneDimensionItertor = (function () {
    function OneDimensionItertor(objects) {
        this.objects = objects;
    }
    OneDimensionItertor.prototype.init = function (pos) {
        var _this = this;
        this.index = search_1.SearchUtils.normedInterpolationIndexOf(this.objects, function (o) { return _this.getPosition(o); }, pos);
        this.updateNextObjPos();
    };
    OneDimensionItertor.prototype.update = function (newPosition) {
        if (newPosition < this.nextObjPosition)
            return false;
        while (this.getPosition(this.objects[++this.index]) < newPosition)
            ;
        this.updateNextObjPos();
        return true;
    };
    OneDimensionItertor.prototype.updateNextObjPos = function () {
        var nextObj = this.objects[this.index + 1];
        this.nextObjPosition = nextObj ? this.getPosition(nextObj) : Number.MAX_VALUE;
    };
    return OneDimensionItertor;
}());
exports.OneDimensionItertor = OneDimensionItertor;
var ParagraphIterator = (function (_super) {
    tslib_1.__extends(ParagraphIterator, _super);
    function ParagraphIterator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphIterator.prototype.getPosition = function (o) {
        return o.startLogPosition.value;
    };
    return ParagraphIterator;
}(OneDimensionItertor));
exports.ParagraphIterator = ParagraphIterator;
var SectionIterator = (function (_super) {
    tslib_1.__extends(SectionIterator, _super);
    function SectionIterator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionIterator.prototype.getPosition = function (o) {
        return o.startLogPosition.value;
    };
    return SectionIterator;
}(OneDimensionItertor));
exports.SectionIterator = SectionIterator;
